<template lang="pug">
	.app
		header(v-show="User.loaded && User.currentUser")
			.left-header
				CustomSelect(:name="'pageValue'" :values="pageValues" :action="changePage" :vModel="page" :options="pageOptions" :style="{'margin-left': '20px'}")
				CustomSelect(:name="'statusValue'" :values="statusValues" :action="changeStatus" :vModel="activeStatus" :options="statusOptions" :style="{'margin-left': '20px'}")
			.right-header
				.profile-wrapper(v-if="User.currentUser")
					span {{User.currentUser.name}}
					.profile-image(:style="{background: `url(\"${User.currentUser.photo}\")`, 'background-size': '100%', 'background-color': 'gray'}")
		CampaignsPage(v-show="User.loaded && User.currentUser" :activeStatus="activeStatus" v-if="page === 'campaigns' && User.loaded")
		OrdersPage(v-show="User.loaded && User.currentUser" :activeStatus="activeStatus" v-else-if="page === 'orders' && User.loaded")
		Auth(v-show="User.loaded && !User.currentUser")
</template>

<script>
	import Screen 									from './../../mixins/screen'

	import { User } 								from './../../services/User'
	import { Layout } 								from './../../services/Layout'

	import CampaignsPage 							from "@/components/Pages/CampaignsPage";
	import OrdersPage 								from "@/components/Pages/OrdersPage";
	import Auth									    from "@/components/User/Auth";
	import CustomSelect 							from "@/components/CustomControls/CustomSelect";


	export default {
		name: 'Dashboard',
		mixins: [Screen],
		screen: {
			updateOn: ['Current User Loaded']
		},
		components: {
			Auth,
			CampaignsPage,
			OrdersPage,
			CustomSelect
		},
		data() {

			this.User = User;
			this.Layout = Layout;

			this.page = 'campaigns';

			this.pageValues = [
				{
					title: 'Campaigns',
					value: 'campaigns'
				},
				{
					title: 'Orders',
					value: 'orders'
				}
			];
			this.statusValues = [
				{
					title: 'All statuses',
					value: 'all'
				},
				{
					title: 'Active',
					value: 'active'
				},
				{
					title: 'Inactive',
					value: 'inactive'
				}
			];

			this.pageOptions = {
				icon: 'fa-align-left',
				addCaret: true
			};
			this.statusOptions = {
				icon: 'fa-dot-circle-o',
				addCaret: true
			};

			return {
				page: 'campaigns',
				activeStatus: 'all',
				showed: true
			};
		},
		methods: {
			collectData() {
				this.page = Layout.page || 'campaigns';
			},
			changePage(value) {
				Layout.changePage(value);
				this.page = Layout.page;
			},
			changeStatus(value) {
				this.activeStatus = value;
			}
		}
	}
</script>

<style lang="sass">

	.app
		height: 100%
		background-color: #1a1b22

		.custom-select
			border: 1px solid #23282c
			background-color: #515b65
			color: white

		>header
			display: flex
			flex-direction: row
			align-items: center
			width: 100%
			min-height: 60px
			height: 60px
			background-color: #2a2b36
			border-bottom: 2px solid #353640
			z-index: 1000

			>.right-header
				align-items: center
				justify-content: end
				gap: 15px
				flex: 1

				>.profile-wrapper
					margin-right: 10px
					display: flex
					flex-direction: row
					align-items: center
					gap: 18px
					color: white
					font-size: 15px

					>.profile-name

					>.profile-image
						width: 40px
						height: 40px
						background-color: gray
						border-radius: 100px
						background-size: 100%


			>.left-header,>.right-header
				display: flex
				flex-direction: row

				>.manage-select
					width: 160px
					margin-left: 20px

</style>
